import { FilmstripIcon } from './FilmstripIcon';

/**
 * author: Google
 * id 10A06B6D-A551-425C-B084-DA3F2239DFA1
 * name filmstrip
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/filmstrip.svg
 * tags
 * - Video / Movie 
 */
export const TheatersIcon = FilmstripIcon;
export default TheatersIcon